<div class="container">
  <p-toast />
  <router-outlet />

  <app-general-feedback-dialog [isFeedbackEnabled]="isSurveyEnabled" [userId]="userId" />
</div>
